import apiHandler from "../function/apiHandler";
const api = new apiHandler();

async function searchAccountsData(payload) {
  try {
    const { data } = await api.post("searchAccounts", payload);
    return data;
  } catch (error) {
    if (error.status === 401) {
      setTimeout(() => {
        window.location.href = "/login";
      }, 500);
      return error;
    }
  }
}

async function checkLogin() {
  try {
    await api.get("check-login");
  } catch (error) {
    if (error.status === 401) {
      setTimeout(() => {
        window.location.href = "/login";
      }, 500);
      return error;
    }
  }
}

async function sweep(payload) {
  try {
    const { data } = await api.post("sweepAccount", payload);
    return data;
  } catch (error) {
    if (error.status === 401) {
      setTimeout(() => {
        window.location.href = "/login";
      }, 500);
      return error;
    }
  }
}

async function getTags() {
  try {
    const { data } = await api.get("getTags");
    return data;
  } catch (error) {
    if (error.status === 401) {
      setTimeout(() => {
        window.location.href = "/login";
      }, 500);
      return error;
    }
  }
}

async function getSites() {
  try {
    const { data } = await api.get("getSites");
    return data;
  } catch (error) {
    if (error.status === 401) {
      setTimeout(() => {
        window.location.href = "/login";
      }, 500);
      return error;
    }
  }
}

async function createAccount(payload) {
  try {
    const { data } = await api.post("createAccount", payload);
    return data;
  } catch (error) {
    if (error.status === 401) {
      setTimeout(() => {
        window.location.href = "/login";
      }, 500);
      return error;
    }
  }
}

async function searchAccountByID(payload) {
  try {
    const { data } = await api.post("searchAccountByID", payload);
    return data;
  } catch (error) {
    if (error.status === 401) {
      setTimeout(() => {
        window.location.href = "/login";
      }, 500);
      return error;
    }
  }
}

async function editAccount(payload) {
  try {
    const { data } = await api.post("editAccount", payload);
    return data;
  } catch (error) {
    if (error.status === 401) {
      setTimeout(() => {
        window.location.href = "/login";
      }, 500);
      return error;
    }
  }
}

async function deleteAccount(payload) {
  try {
    const { data } = await api.post("deleteAccount", payload);
    return data;
  } catch (error) {
    if (error.status === 401) {
      setTimeout(() => {
        window.location.href = "/login";
      }, 500);
      return error;
    }
  }
}

async function searchOrder(payload) {
  try {
    const { data } = await api.post("searchOrder", payload);
    return data;
  } catch (error) {
    if (error.status === 401) {
      setTimeout(() => {
        window.location.href = "/login";
      }, 500);
      return error;
    }
  }
}

async function recheckOrder(payload) {
  try {
    const { data } = await api.post("recheckOrder", payload);
    return data;
  } catch (error) {
    if (error.status === 401) {
      setTimeout(() => {
        window.location.href = "/login";
      }, 500);
      return error;
    }
  }
}
async function fulfillOrder(payload) {
  try {
    const { data } = await api.post("fulfillOrder", payload);
    return data;
  } catch (error) {
    if (error.status === 401) {
      setTimeout(() => {
        window.location.href = "/login";
      }, 500);
      return error;
    }
  }
}
async function deleteOrder(payload) {
  try {
    const { data } = await api.post("deleteOrder", payload);
    return data;
  } catch (error) {
    if (error.status === 401) {
      setTimeout(() => {
        window.location.href = "/login";
      }, 500);
      return error;
    }
  }
}
async function createProof(payload) {
  try {
    const { data } = await api.post("createProof", payload);
    return data;
  } catch (error) {
    if (error.status === 401) {
      setTimeout(() => {
        window.location.href = "/login";
      }, 500);
      return error;
    }
  }
}
async function confirmOrder(payload) {
  try {
    const { data } = await api.post("confirmOrder", payload);
    return data;
  } catch (error) {
    if (error.status === 401) {
      setTimeout(() => {
        window.location.href = "/login";
      }, 500);
      return error;
    }
  }
}
async function deliverUrls(payload) {
  try {
    const { data } = await api.post("deliverUrls", payload);
    return data;
  } catch (error) {
    if (error.status === 401) {
      setTimeout(() => {
        window.location.href = "/login";
      }, 500);
      return error;
    }
  }
}

async function createOrder(payload) {
  try {
    const { data } = await api.post("createOrder", payload);
    return data;
  } catch (error) {
    if (error.status === 401) {
      setTimeout(() => {
        window.location.href = "/login";
      }, 500);
      return error;
    }
  }
}

async function bulkSweepAccounts(payload) {
  try {
    const { data } = await api.post("accountBulkSweep", payload);
    return data;
  } catch (error) {
    if (error.status === 401) {
      setTimeout(() => {
        window.location.href = "/login";
      }, 500);
      return error;
    }
  }
}

export {
  searchAccountsData,
  sweep,
  getTags,
  getSites,
  createAccount,
  searchAccountByID,
  editAccount,
  deleteAccount,
  searchOrder,
  recheckOrder,
  fulfillOrder,
  deleteOrder,
  createProof,
  confirmOrder,
  deliverUrls,
  createOrder,
  checkLogin,
  bulkSweepAccounts,
};
